import { createAsyncThunk } from "@reduxjs/toolkit"
import {
  post,
  get,
  del,
  put,
  formDataPost,
  formDataPut,
} from "helpers/api_helper"

// Get all templates
export const getAllTemplates = createAsyncThunk(
  "Templates/getAllTemplates",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await post("/admin/card-template/all", payload)
      return response
    } catch (error) {
      return rejectWithValue(error.response.data)
    }
  }
)

// Delete template
export const deleteTemplate = createAsyncThunk(
  "Templates/deleteTemplate",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await del("/admin/card-template/delete", payload)
      return response
    } catch (error) {
      return rejectWithValue(error.response.data)
    }
  }
)

// Update template
export const updateTemplate = createAsyncThunk(
  "Templates/updateTemplate",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await formDataPut("/admin/card-template/update", payload)
      return response
    } catch (error) {
      return rejectWithValue(error.response.data)
    }
  }
)

// Add template
export const addTemplate = createAsyncThunk(
  "Templates/addTemplate",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await formDataPost("/admin/card-template/add", payload)
      return response
    } catch (error) {
      return rejectWithValue(error.response.data)
    }
  }
)

// Get template by id
export const getTemplateById = createAsyncThunk(
  "Templates/getTemplateById",
  async (payload, { rejectWithValue }) => {
    try {
      console.log("API Request payload:", payload)
      const response = await post("/admin/card-template/by-card-type", payload)
      console.log("API Response:", response)
      return response
    } catch (error) {
      console.error("API Error:", error)
      return rejectWithValue(error.response.data)
    }
  }
)
